import React, { useContext } from 'react';
import { IStyleContext, StyleContext } from '../../styleState/styleContext';
import { TFileId, TLanguageIDs, ICustomGroups, TMediaFileType } from 'types';
import { aspectRatiosForStyleSettings } from 'appConstants';
import Text from 'components/Text/Text';
import { StyleSettingsImageUploaderNew } from 'components/StyleSettingsImageUploader/StyleSettingsImageUploaderNew';
import { FileSectionForStyleSettingsNew } from 'components/UploaderAndDownloader/FileSectionForStyleSettingsNew';

interface IProps {
	group: ICustomGroups;
	languageId: TLanguageIDs;
	showGroupLoader: () => void;
	hideGroupLoader: () => void;
	groupLoading: boolean;
	isMakeImageRequest: boolean;
	setMediaSettingsFromNormalDisplay: (
		languageId: Nullable<TLanguageIDs>,
		groupId: string,
		translationId: string,
		mediaFileType: TMediaFileType,
		sourceUrl: string,
		fileId: TFileId,
	) => void;
}

export const NormalDisplay: React.FC<IProps> = ({
	group,
	languageId,
	showGroupLoader,
	hideGroupLoader,
	groupLoading,
	isMakeImageRequest,
	setMediaSettingsFromNormalDisplay,
}) => {
	const { changeTypeOfModalWindow } = useContext<IStyleContext>(StyleContext);
	const isSlider = group.isMultipleItems;
	const isMultipleImagesInBlock = group.key === 'cards' || group.key === 'split_payment_images';
	const listOfTypesOfMediaContent = [1, 2];

	const PDFFilesOfBlockWithMultipleImages = isMultipleImagesInBlock
		? group.items.filter((item) => item.mediaFileType === 3)
		: [];

	const handleUploadPdf = ({
		translationId,
		fileId,
		sourceUrl,
	}: {
		translationId: string;
		fileId: string;
		sourceUrl: string;
	}) => {
		setMediaSettingsFromNormalDisplay(languageId, group.id, translationId, 3, sourceUrl, fileId);
	};

	const handleDeletePdf = (translationId: string) => {
		setMediaSettingsFromNormalDisplay(languageId, group.id, translationId, 3, '', null);
	};

	return (
		<div className="flex flex-col gap-4">
			<div className="flex gap-4">
				{group.items.map((el) =>
					listOfTypesOfMediaContent.includes(el.mediaFileType) ? (
						<StyleSettingsImageUploaderNew
							key={el.translationId}
							filePath={el.filePath}
							translationId={el.translationId}
							isNeedImgHeading={!isSlider && isMultipleImagesInBlock}
							itemKey={el.key}
							mediaFileType={el.mediaFileType}
							maxFileSizeMB={{ img: 1, gif: isMultipleImagesInBlock ? 15 : 1 }}
							languageId={languageId}
							groupId={group.id}
							groupKey={group.key}
							verticalAspectRatio={aspectRatiosForStyleSettings[group.key]?.vertical}
							horizontalAspectRatio={aspectRatiosForStyleSettings[group.key]?.horizontal}
							showGroupLoader={showGroupLoader}
							hideGroupLoader={hideGroupLoader}
							setMediaSettingsFromNormalDisplay={setMediaSettingsFromNormalDisplay}
							groupLoading={groupLoading}
							isMakeImageRequest={isMakeImageRequest}
						/>
					) : (
						<React.Fragment key={el.translationId}></React.Fragment>
					),
				)}
			</div>
			{PDFFilesOfBlockWithMultipleImages.map((item) => (
				<div key={item.translationId} className="flex flex-col gap-2">
					<Text translationNameSpace="mediaSettings" translationKey={item.key} size="ml" weight="bold" />
					<FileSectionForStyleSettingsNew
						item={item}
						accept={['pdf']}
						maxFileSizeMB={20}
						onUpload={({ fileId, sourceUrl }) =>
							handleUploadPdf({ translationId: item.translationId, fileId, sourceUrl })
						}
						onDelete={() => handleDeletePdf(item.translationId)}
						onSizeExceeded={() => changeTypeOfModalWindow('PDFMenuSizeExceeded')}
						onInvalidFormat={() => changeTypeOfModalWindow('invalidPdfFileFormat')}
						onUploadError={() => changeTypeOfModalWindow('fileUploadError')}
						onViewError={() => changeTypeOfModalWindow('fileDownloadError')}
					/>
				</div>
			))}
		</div>
	);
};
